module.exports = __webpack_public_path__ + "static/media/company__rtelecom--xxl.e86c7a0a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/company__rtelecom--xxl.png
// module id = 842
// module chunks = 0